"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderDay = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment/moment"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
var _StyledPickersDay = require("./StyledPickersDay");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const {
  getStartDay
} = _paulCorePackage.functions;
const RenderDay = _ref => {
  let {
    day,
    // selectedDate,
    pickersDayProps,
    fromDay,
    toDay,
    setParams,
    setFromDay,
    setToDay,
    openTo
  } = _ref;
  const isFirstDay = fromDay && openTo === 'week' && (0, _moment.default)(day).isSame((0, _moment.default)(fromDay), 'day');
  const isLastDay = toDay && openTo === 'week' && (0, _moment.default)(day).isSame((0, _moment.default)(toDay), 'day');
  const isSelectDay = toDay && openTo === 'day' && (0, _moment.default)(day).isSame((0, _moment.default)(toDay), 'day');
  const dayIsBetween = fromDay && toDay && openTo === 'week' && (0, _moment.default)(day).isBetween(getStartDay(fromDay), getStartDay(toDay), null, '[]');
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, (0, _moment.default)(day).isoWeekday() === 1 && /*#__PURE__*/_react.default.createElement(_material.Button, {
    sx: {
      position: 'absolute',
      fontSize: '0.75rem',
      left: '5px',
      height: '36px',
      minWidth: '36px',
      borderRadius: '50%'
    },
    variant: "text",
    onClick: () => {
      setParams({
        [_constants.calendarParams.dateType]: _constants.constDateType.week
      });
      setFromDay((0, _moment.default)(day));
      setToDay((0, _moment.default)(day).add(6, 'days'));
    }
  }, (0, _moment.default)(day).isoWeek()), /*#__PURE__*/_react.default.createElement(_StyledPickersDay.StyledPickersDay, _extends({}, pickersDayProps, {
    disableMargin: true,
    dayIsBetween: dayIsBetween,
    isFirstDay: isFirstDay,
    isLastDay: isLastDay,
    isSelectDay: isSelectDay,
    sx: isSelectDay || dayIsBetween || isLastDay ? {
      color: _constants.colors['main-color-cl-08'],
      '&.Mui-selected': {
        backgroundColor: '#1976d2 !important',
        color: "".concat(_constants.colors['main-color-cl-08'], " !important")
      }
    } : {},
    onClick: () => {
      setParams({
        [_constants.calendarParams.dateType]: _constants.constDateType.day
      });
    }
  }), (0, _moment.default)(day).date()));
};

/** @todo add types */
exports.RenderDay = RenderDay;
const FIX_ME_LATER = _propTypes.default.any;
RenderDay.propTypes = {
  day: FIX_ME_LATER,
  // TDate
  selectedDate: _propTypes.default.arrayOf(FIX_ME_LATER),
  // TDate[]
  pickersDayProps: FIX_ME_LATER,
  // PickersDayProps<TDate>
  fromDay: _propTypes.default.shape({
    [_propTypes.default.string]: FIX_ME_LATER
  }),
  toDay: _propTypes.default.shape({
    [_propTypes.default.string]: FIX_ME_LATER
  }),
  setParams: _propTypes.default.func,
  setFromDay: _propTypes.default.func,
  setToDay: _propTypes.default.func,
  openTo: _propTypes.default.string
};